<template>
    <div class="col-md-12">
        <div class="card" v-if="showSetupForm === true">
            <div class="card-header">
                <h4>Lets setup your instagram account</h4>
            </div>
            <div class="card-body">
                <div class="col-md-12 mb-3">
                    <form class="form mb-3">
                        <div class="form-group">
                            <div class="row">
                                <div class="col-md-12">
                                    <label>Select hashtags to follow</label>
                                    <div
                                        class="btn btn-primary ml-3"
                                        @click="addHashtag"
                                    >
                                        Add
                                    </div>
                                    <div v-if="hashtagsToFollow.length">
                                        You can add
                                        {{ 10 - hashtagsToFollow.length }} more
                                        hashtags
                                    </div>
                                    <div
                                        class="error"
                                        v-if="!hashtagsToFollow.length"
                                    >
                                        You must add at least on hashtag
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                    <div
                        class="col-md-3 badge-light badge mr-4 pt-2 pb-2 mt-2 pr-3 pl-3"
                        v-for="(hashtag, idx) in hashtagsToFollow"
                    >
                        <div
                            class="remove-button"
                            @click="removeHashtag(idx)"
                        >
                            <i class="fas fa-trash"></i>
                        </div>
                        <input
                            type="text"
                            class="form-control"
                            placeholder="eg. #hashtag"
                            v-model="hashtag.title"
                        />
                    </div>
                </div>
                <div class="col-md-12 mb-3">
                    <button
                        :disabled="!setupFormValid || saving"
                        class="btn btn-primary"
                        @click="completeSetup"
                    >
                        Save Settings
                    </button>
                </div>
            </div>
        </div>
        <div v-if="showSetupForm === false">
            <div class="card">
                <div class="card-header">
                    Instagram setup completed
                </div>
                <div class="card-body">
                    We will now start getting data about your profile, hashtags
                    and locations. It may take up to one working day to see the
                    first results in your dashboard
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import InstagramService from '../../services/instagram-service'
export default {
    data() {
        return {
            showSetupForm: true,
            hashtagsToFollow: [],
            saving: false
        }
    },
    computed: {
        setupFormValid() {
            return this.hashtagsToFollow.length > 0;
        }
    },
    methods: {
        addHashtag() {
            if (this.hashtagsToFollow.length > 9) return

            this.hashtagsToFollow.push({title: ''})
        },
        removeHashtag(idx) {
            this.hashtagsToFollow.splice(idx, 1)
        },
        async completeSetup() {

            const data = {
                hashtags: this.hashtagsToFollow.map(hashtag => hashtag.title)
            }
            this.saving = true;
            await InstagramService.settings.save({data})
            this.saving = false;
            this.showSetupForm = false;
            setTimeout(function() {
                window.location.href = location.href + "?firstTime=1";
            }, 3000);
        },
    }
}
</script>